export const HEADER = {
  LINK_IDENTITY_LABEL: 'COMMON_HEADER_LINK_IDENTITY_LABEL',
  LINK_IDENTITY_POSTMEN_LABEL: 'COMMON_HEADER_LINK_IDENTITY_POSTMEN_LABEL',
  LINK_ACTIVITY_LABEL: 'COMMON_HEADER_LINK_ACTIVITY_LABEL',
  LINK_STATISTICS_LABEL: 'COMMON_HEADER_LINK_STATISTICS_LABEL',
  MENU_CLOSE: 'COMMON_HEADER_MENU_CLOSE',
  MENU_OPEN: 'COMMON_HEADER_MENU_OPEN',
  MISSING_TRANSLATION: 'COMMON_HEADER_MISSING_TRANSLATION',
  ALTERNATE_TRANSLATION: 'COMMON_HEADER_ALTERNATE_TRANSLATION',
  WORDING_LANGFR: 'COMMON_HEADER_WORDING_LANGFR',
  WORDING_LANGEN: 'COMMON_HEADER_WORDING_LANGEN',
  LOGO_ALTERNATIVE_TEXT: 'COMMON_HEADER_LOGO_ALTERNATIVE_TEXT',
};
